export const ADMIN_ROLES = [
  'system-admins',
  'PWS Account Admin',
  '120Employee',
  'PWS System Admin'
]
